import { Component, ElementRef, Input, OnDestroy, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { ChatService } from 'src/app/services/chat.service';
import { environment } from 'src/environments/environment';
import { ModalIniciarConversaComponent } from '../modal-iniciar-conversa/modal-iniciar-conversa.component';
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { PhonePipe } from 'src/app/shared/validators/pipes/phone.pipe';
import { ModalMsgStartChatWhatsappComponent } from '../modal-msg-start-chat-whatsapp/modal-msg-start-chat-whatsapp.component';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import Swal from 'sweetalert2';
import { CountriesDDI } from "src/app/variables/countries-phones";
import { TicketService } from 'src/app/services/ticket.service';
import { FuncoesGlobaisService } from 'src/app/services/funcoes-globais.service';
import { ModalContatosComponent } from '../modal-contatos/modal-contatos.component';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { TokenService } from 'src/app/core/token/token.service';
import { ModalVincularContatosComponent } from '../modal-vincular-contatos/modal-vincular-contatos.component';
import { ModalEnviarEmailComponent } from '../modal-enviar-email/modal-enviar-email.component';
@Component({
  selector: 'app-conversa-zap',
  templateUrl: './conversa-zap.component.html',
  styleUrls: ['./conversa-zap.component.scss']
})
export class ConversaZapComponent implements OnInit, OnDestroy {

  nome: string = '';
  telefone: string = '';
  celular: string = '';
  cliente: any = {
    id: ''
  };
  searchText: string = '';
  searchText$ = new Subject<string>();
  lista = []
  contatosPagination;
  contatosConfigPagination: any = environment.getPaginationDefault();
  has_contato;
  codigo_pais = {
    valor: '',
    id: null
  }

  @Input() mensagemConversa;
  @Output() contatoCadastrado = new EventEmitter<void>();
  selector: string;
  newSubs: Subscription;
  is_ddg: boolean = false;
  mascara: string = '';
  render: boolean = true;
  templatesMeta: Array<any> = [];
  solicitantes_habilitados: any = {
    solicitante_cliente: true,
    solicitante_contato: true,
    solicitante_operador: true
  };
  novoContato: any = {
    codigo_pais_id: '',
    codigo_pais_id_telefone: '',
    codigo_pais: '',
    codigo_pais_telefone: ''
  };
  permissao = {
    EditarCliente: this.tokenService.checkPermissions('@EditarCliente'),
    EditarContatoChat: this.tokenService.checkPermissions('@EditarContatoChat'),
    CriarNovoContatoChat: this.tokenService.checkPermissions('@CriarNovoContatoChat'),
    VincularContatos: this.tokenService.checkPermissions("@VincularContatosChat")
  };
  hasIntegracao;
  integracaoEmailChatDisponivel = false;
  provider_id;
  nomeEmpresa: string = '';
  operador: string = '';
  contatosSelecionados: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private chatService: ChatService,
    private elemRef: ElementRef,
    private toastr: ToastrService,
    public translate: TranslateService,
    private phonePipe: PhonePipe,
    private cdRef: ChangeDetectorRef,
    private whatsappService: WhatsappService,
    private ticketService: TicketService,
    private FuncoesGlobaisService: FuncoesGlobaisService,
    private dadosEmpresaService: DadosEmpresaService,
    private tokenService: TokenService
  ) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
  }

  changeDdi(event) {
    if (event === undefined) {
      this.codigo_pais = { valor: '', id: 0 }
      this.telefone = ''
      return
    }
    this.render = false;
    this.codigo_pais.valor = event && event.valor ? event.valor : '';
    this.codigo_pais.id = event && event.id ? event.id : null;

    this.mascara = this.setMascara(this.telefone, event.valor)
    this.cdRef.detectChanges();
    this.render = true;

  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
    this.contatosConfigPagination.total_registros = 4;
    this.listagemContato();
    this.verificaSolicitantesHabilitados();
    this.obterDados();

    this.searchText$.pipe(
      debounceTime(1000)
    ).subscribe(value => {
      this.filtrarApi(value)
    }, (error) => console.error('searchTxt', error));
    this.verificaIntegracao();
    this.verificaIntegracaoEmailChat();
  }

  verificaIntegracaoEmailChat(): void {
    this.newSubs = this.chatService.validarIntegracaoChamarEmailChat().subscribe({
      next: (cfg) => {
        this.integracaoEmailChatDisponivel = !!cfg?.integracao_email_chat_disponivel;
      },
      error: (error) => console.error('verificaIntegracaoEmailChat', error)
    });
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  changePesquisa(value: string) {
    this.contatosSelecionados = [];
    this.searchText$.next(value);
  }

  verificaSolicitantesHabilitados(): void {
    this.newSubs = this.ticketService.getAberturaTicketPadrao()
      .subscribe({
        next: (results) => {
          this.solicitantes_habilitados.solicitante_cliente = results.categorizacaoClientePadrao.solicitante_cliente;
          this.solicitantes_habilitados.solicitante_contato = results.categorizacaoClientePadrao.solicitante_contato;
          this.solicitantes_habilitados.solicitante_operador = results.categorizacaoClientePadrao.solicitante_operador;
        }, error: (error) => console.error('verificaSolicitantesHabilitados')
      });
  }

  checkDdg($event) {
    this.is_ddg = $event.target.checked
  }

  verificaDdg(telefone: string) {
    return telefone && telefone.includes('0800');
  }

  filtrarApi(filtro) {
    var payload = {
      filtro_body: {
        pesquisa: filtro
      }
    }
    this.contatosConfigPagination.total_registros = 4;
    this.contatosConfigPagination.pagina = 1
    this.newSubs = this.chatService.listAllContatos(this.contatosConfigPagination, payload).subscribe(
      (result) => {
        this.lista = result.lista
        this.contatosPagination = result.meta.paginate;
      }, (error) => console.error('filtrarApi', error)
    )
  }

  listagemContato() {
    var payload = {
      filtro_body: {
        pesquisa: this.searchText
      }
    }
    this.contatosConfigPagination.total_registros = 4;
    this.newSubs = this.chatService.listAllContatos(this.contatosConfigPagination, payload).subscribe(
      (result) => {
        this.lista = this.FuncoesGlobaisService.regraDDG(result.lista)
        this.contatosPagination = result.meta.paginate;
      }, (error) => console.error('listagemContato', error)
    )
  }

  obterQuantidadeColunasTabelaContatos(): number {
    let quantidadeColunasTabela = 6;

    if (this.solicitantes_habilitados.solicitante_contato || this.solicitantes_habilitados.solicitante_operador) {
      quantidadeColunasTabela += 1;
    }

    if (this.solicitantes_habilitados.solicitante_cliente) {
      quantidadeColunasTabela += 1;
    }

    return quantidadeColunasTabela;
  }

  paginarListagem(pagina) {
    this.contatosSelecionados = [];
    this.contatosConfigPagination.pagina = pagina;
    this.listagemContato();
  }

  close(result?) {
    this.activeModal.close();
  }

  salvarIniciarConversa() {
    var payload = {
      clienteContato: {
        "cliente_id": this.cliente && this.cliente.id ? this.cliente.id : null,
        "is_padrao": false,
        "descricao": this.nome,
        "celular": this.telefone,
        "telefone": this.telefone,
        "possui_whatsapp": true,
        "codigo_pais": this.codigo_pais.valor
      }
    };

    this.newSubs = this.chatService.createContato(payload).subscribe(
      (result) => {
        if (result) {
          this.has_contato = false;
          this.abrirConversa(result.clienteContato)
          this.listagemContato()
        }
      }, (error) => console.error('salvarIniciarConversa', error)
    )
  }

  // LEGADO
  abrirConversa(contato?, fromCrud?) {
    if (!fromCrud && this.verificaNumeros(contato)) return;

    this.newSubs = this.chatService.obterIntegracaoAtiva()
      .subscribe({
        next: (results) => {
          if (results) {
            const modalRef = this.modalService.open(ModalMsgStartChatWhatsappComponent, {
              scrollable: true,
              windowClass: 'modal-custom-milvus',
              size: 'medio',
              keyboard: false,
              backdrop: 'static',
            });

            let data = {
              provider_id: results?.provider_id,
              number: contato.celular,
              integration_id: results?.id,
              ...results
            };

            if (results?.provider_id === 2) {
              data['message'] = results?.mensagem_inicia_conversa_whatsapp
            };

            modalRef.componentInstance.data = data;
            modalRef.result.then(
              (result) => {
                if (result) {
                  var _contato = result;

                  _contato.from = results.numero;
                  _contato.numero_destino = contato.celular;
                  _contato.contato_id = contato.id;
                  _contato.numero_contato = contato.celular;
                  _contato.chamado_id = null;
                  _contato.nome_contato = contato.descricao;
                  _contato.contato_id = contato.id;
                  _contato.cliente_id = contato.cliente_id;

                  this.newSubs = this.whatsappService
                    .wppIniciarConversaUnificado(_contato)
                    .subscribe(
                      (results) => {
                        this.activeModal.close(results.chat);
                      }
                    );
                }
              }
            )
          } else {
            this.toastr.show(this.translate.instant('NAO_POSSUI_INTEGRACAO'), '', environment.toastrConfig('warning'));
          }
        }, error: (error) => console.error('abrirConversa', error)
      });
  }

  abrirConversaPorSaida(contato?, fromCrud?) {
    if (!this.hasIntegracao) {
      Swal.fire({
        title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_INTEGRACAO'),
        icon: 'info',
        confirmButtonText: "Ok",
        position: "top"
      });

      return;
    }
    if (!fromCrud && this.verificaNumeros(contato)) return;

    this.newSubs = this.chatService.obterIntegracaoAtivaSaida()
      .subscribe({
        next: (results) => {
          if (results.dropDown.length) {
            if (!results.filasAtivas.length) {
              Swal.fire({
                title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_FILA'),
                icon: 'info',
                confirmButtonText: 'Ok',
                position: 'top'
              });
              return;
            } else if (!results.integracoes.length) {
              Swal.fire({
                title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_NUM_SAIDA'),
                icon: 'info',
                confirmButtonText: 'Ok',
                position: 'top'
              });
              return;
            } else {
              const modalRef = this.modalService.open(ModalMsgStartChatWhatsappComponent, {
                scrollable: true,
                windowClass: 'modal-custom-milvus',
                size: 'medio',
                keyboard: false,
                backdrop: 'static',
              });

              let data = {
                provider_id: results?.provider_id,
                number: contato.celular,
                integration_id: results?.id,
                contato: contato?.descricao,
                empresa: this.nomeEmpresa,
                operador: this.operador,
                ...results
              };

              if (results?.provider_id === 2) {
                data['message'] = results?.mensagem_inicia_conversa_whatsapp
              };

              modalRef.componentInstance.data = data;
              modalRef.result.then(
                (result) => {
                  if (result && result.provider_id) {
                    var _contato = result;

                    _contato.from = results.numero;
                    _contato.numero_destino = contato.celular;
                    _contato.contato_id = contato.id;
                    _contato.numero_contato = contato.celular;
                    _contato.chamado_id = null;
                    _contato.nome_contato = contato.descricao;
                    _contato.contato_id = contato.id;
                    _contato.cliente_id = contato.cliente_id;

                    this.newSubs = this.whatsappService
                      .wppIniciarConversaUnificado(_contato)
                      .subscribe(
                        (results) => {
                          this.activeModal.close(results.chat);
                        },
                      );
                  }
                }
              )
            }
          } else {
            Swal.fire({
              title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_INTEGRACAO'),
              icon: 'info',
              confirmButtonText: "Ok",
              position: "top"
            });
          }
        }, error: (error) => console.error('abrirConversaPorSaida', error)
      });
  }

  abrirConversaEmailPorSaida(contato): void {
    const emailContato = (contato?.email || '').trim();
    if (!emailContato) {
      this.toastr.show('Contato sem e-mail cadastrado.', '', environment.toastrConfig('warning'));
      return;
    }
    if (!this.integracaoEmailChatDisponivel) {
      Swal.fire({
        title: this.translate.instant('AVISO_BLOQUEADO_MANDAR_CHAT_EMAIL'),
        icon: 'info',
        confirmButtonText: 'Ok',
        position: 'top'
      });
      return;
    }
    this.newSubs = this.chatService.buscarCaixaEmailOperador().subscribe({
      next: (ctx) => {
        const caixasDisponiveis = ctx?.caixas || [];
        if (!caixasDisponiveis.length) {
          Swal.fire({
            title: this.translate.instant('AVISO_BLOQUEADO_MANDAR_CHAT_EMAIL'),
            icon: 'info',
            confirmButtonText: 'Ok',
            position: 'top'
          });
          return;
        }
        this.selecionarCaixaEmailEAbrirModalEnviarEmail(contato, caixasDisponiveis);
      },
      error: (error) => console.error('abrirConversaEmailPorSaida', error)
    });
  }

  private selecionarCaixaEmailEAbrirModalEnviarEmail(contato, caixasDisponiveis: any[]): void {
    if (caixasDisponiveis.length === 1) {
      this.abrirModalEnviarEmailIniciarConversa(contato, caixasDisponiveis[0]);
      return;
    }

    const opcoesCaixaEmail: Record<string, string> = {};
    caixasDisponiveis.forEach((caixaEmail, indiceCaixa) => {
      const descricaoFilaAtendimento = caixaEmail.fila_atendimento_descricao ? ` - ${caixaEmail.fila_atendimento_descricao}` : '';
      opcoesCaixaEmail[String(indiceCaixa)] = `${caixaEmail.email}${descricaoFilaAtendimento}`;
    });

    Swal.fire({
      title: this.translate.instant('SELECIONE_CAIXA_EMAIL'),
      input: 'select',
      inputOptions: opcoesCaixaEmail,
      inputPlaceholder: this.translate.instant('SELECIONE_CAIXA_EMAIL'),
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: this.translate.instant('CANCELAR'),
      position: 'top'
    }).then((resultadoSelecao) => {
      if (!resultadoSelecao.isConfirmed || resultadoSelecao.value === undefined || resultadoSelecao.value === '') {
        return;
      }
      const indiceCaixaSelecionada = Number(resultadoSelecao.value);
      const caixaEmailEscolhida = caixasDisponiveis[indiceCaixaSelecionada];
      if (caixaEmailEscolhida) {
        this.abrirModalEnviarEmailIniciarConversa(contato, caixaEmailEscolhida);
      }
    });
  }

  private abrirModalEnviarEmailIniciarConversa(contato, caixaEmailEscolhida): void {
    const modalRef = this.modalService.open(ModalEnviarEmailComponent, {
      backdrop: 'static',
      windowClass: 'modal-custom-milvus',
      keyboard: false,
      size: 'grande',
      scrollable: false,
      centered: false
    });
    modalRef.componentInstance.chatEmailData = {
      is_iniciar_conversa: true,
      destinatario: (contato?.email || '').trim(),
      contato_id: contato.id,
      caixa: caixaEmailEscolhida
    };
    modalRef.result.then((resultado) => {
      if (resultado) {
        this.activeModal.close(resultado);
      }
    }).catch(() => {});
  }

  verificaTelefone() {
    var telefone = this.is_ddg ? '+55' + this.telefone : this.codigo_pais.valor + this.telefone;

    this.newSubs = this.chatService.getByTelefone(telefone).subscribe(
      (result) => {
        if (result) {
          this.toastr.show(this.translate.instant('CONTATO_JA_EXISTE'), "", environment.toastrConfig("warning"));
          this.has_contato = true;
        } else {
          this.toastr.show(this.translate.instant("NUMERO_NAO_CADASTRADO"), "", environment.toastrConfig("success"));
          this.has_contato = false;
        }
      }, (error) => console.error('verificaTelefone', error)
    )
  }

  valid() {
    return this.has_contato || this.nome === ''
  }

  setMascara(telefone, ddi) {
    return this.phonePipe.showMascaraInput(telefone, ddi)
  }

  validateCountryPhoneLength(phone: string) {
    if (this.codigo_pais.valor && phone) {
      let countryPhoneLength = 11; // default BR

      const country = CountriesDDI.filter(country => country.phone === this.codigo_pais.valor.toString());

      if (country.length > 0) {
        const len = country[0].phoneLength;

        if (len) {
          countryPhoneLength = Array.isArray(len) ? len[0] : len;
        }
      }

      return phone.length < countryPhoneLength;
    }
    return false;
  }

  abrirModalContato(contato?): void {
    const modalRef = this.modalService.open(ModalContatosComponent, {
      scrollable: false,
      windowClass: 'modal-custom-milvus',
      size: 'medio',
      keyboard: false,
      backdrop: 'static'
    });

    modalRef.componentInstance.solicitantes = this.solicitantes_habilitados;
    modalRef.componentInstance.contato = contato ? contato : this.novoContato;
    modalRef.componentInstance.origem_chat = true;
    modalRef.result.then(result => {
      if (result) {
        this.contatoCadastrado.emit();
        if (result.conversar) {
          this.abrirConversa(result.chat, true);
        } else {
          this.listagemContato();
        }
      }
    });
  }

  verificaNumeros(contato): boolean {
    if (!contato.celular && !contato.telefone) {
      this.mostraAviso(this.translate.instant('INICIAR_CONVERSA_AVISO_CONTATO'));
      return true;
    } else if (contato.celular && !contato.telefone) {
      if (!contato.app_celular || contato.app_celular.indexOf(1) === -1) {
        this.mostraAviso(this.translate.instant('SELECIONAR_WPP_PARA_CONVERSAR'));
        return true;
      } else {
        return false;
      }
    } else if (contato.telefone && !contato.celular) {
      if (!contato.app_telefone || contato.app_telefone.indexOf(1) === -1) {
        this.mostraAviso(this.translate.instant('SELECIONAR_WPP_PARA_CONVERSAR'));
        return true;
      } else {
        return false;
      }
    } else {
      if ((!contato.app_celular || contato.app_celular.indexOf(1) === -1) && (!contato.app_telefone || contato.app_telefone.indexOf(1) === -1)) {
        this.mostraAviso(this.translate.instant('SELECIONAR_WPP_PARA_CONVERSAR'));
        return true;
      } else {
        return false;
      }
    }
  }

  mostraAviso(msg): void {
    Swal.fire({
      title: msg,
      icon: 'info',
      confirmButtonText: 'Ok',
      position: 'top'
    });
  }

  obterDados() {
    this.newSubs = this.dadosEmpresaService.obterDados().subscribe(
      (result) => {
        const res = (result as any)?.result || (result as any)?.results || result;
        if (res && res.empresa) {
          Object.keys(res.empresa).forEach((e) => {
            res.empresa[e] = (res.empresa[e] === null || res.empresa[e] === undefined) ? '' : res.empresa[e]
          })
        }
        this.nomeEmpresa = result?.empresa?.nome_fantasia ? result.empresa.nome_fantasia : '';
        this.novoContato.codigo_pais_id = result?.empresa?.codigo_pais_id ? result.empresa.codigo_pais_id : null;
        this.novoContato.codigo_pais = result?.empresa?.ddi ? result.empresa.ddi : null;
        this.novoContato.codigo_pais_id_telefone = result?.empresa?.codigo_pais_id ? result.empresa.codigo_pais_id : null;
        this.novoContato.codigo_pais_telefone = result?.empresa?.ddi ? result.empresa.ddi : null;
      }, (error) => console.error('obterDados', error)
    )
  }

  verificaIntegracao() {
    this.newSubs = this.chatService.obterIntegracaoAtiva().subscribe(
      (result) => {
        if (result) {
          this.hasIntegracao = true;
          this.provider_id = result.provider_id;
          this.operador = result.operador;
        } else {
          this.hasIntegracao = false;
        }
      }, (error) => console.error('verificaIntegracao', error)
    );
  }

  selecionaTodos(): void {
    var _checkboxes = this.elemRef.nativeElement.querySelectorAll('.custom-control-input');
    var _value = _checkboxes[0].checked;
    _checkboxes.forEach(checkbox => {
      if (checkbox.checked !== _value) {
        checkbox.checked = _value;
      }
    });

    if (_value) {
      this.lista.forEach(e => {
        if (this.contatosSelecionados.indexOf(e.id) === -1) {
          this.contatosSelecionados.push(e.id)
        }
      })
    } else {
      this.lista.forEach(e => {
        if (this.contatosSelecionados.indexOf(e.id) !== -1) {
          this.contatosSelecionados.splice(this.contatosSelecionados.indexOf(e.id), 1)
        }
      })
    }
  }

  selecionaContato(event: any, id: any): void {
    if (event) {
      this.contatosSelecionados.push(id)
    } else {
      this.contatosSelecionados.splice(this.contatosSelecionados.indexOf(id), 1)
    }
  }

  vincularContatos(): void {
    if (this.contatosSelecionados.length > 1) {
      this.chatService.preVinculoContatos({ contato_selecionado_ids: this.contatosSelecionados })
        .subscribe({
          next: (results) => {
            if (results && results.contatos) {
              const modalRef = this.modalService.open(ModalVincularContatosComponent, {
                scrollable: false,
                windowClass: 'modal-custom-milvus',
                size: 'medio',
                keyboard: false,
                backdrop: 'static'
              });

              modalRef.componentInstance.contatos = results.contatos;
              modalRef.result.then(results => {
                if (results) {
                  this.toastr.show(this.translate.instant('VINCULACAO_EM_ANDAMENTO'), '', environment.toastrConfig('success'));
                  this.contatosSelecionados = [];
                  this.listagemContato();
                }
              });
            }
          }, error: (error) => {
            if (error?.error_msg) {
              Swal.fire({
                text: error.error_msg,
                icon: 'info',
                confirmButtonText: 'Ok',
                position: 'top',
                customClass: {
                  content: 'swal-only-text'
                }
              });
            }
          }
        });
    }
  }
}
